import React from 'react';
import ReactDOM from 'react-dom';
import { Global, css } from '@emotion/core';
import minireset from 'emotion-minireset';
import { Provider } from 'react-redux';
import store from './store';
import App from './app';
import * as serviceWorker from './service-worker';

const globalStyles = [
  minireset,
  css`
    html {
      background: #000;
      color: #000;
      user-select: none;
    }
    body {
      height: -webkit-fill-available;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
      font-size: 20px;
    }
    code {
      font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    }
  `,
];

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Global styles={globalStyles} />
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
